"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowRootWithInlineLabel = exports.ColumnRootWithInlineLabel = exports.RowRoot = exports.ColumnRoot = exports.NotInlineRoot = exports.BaseRoot = exports.inlineStyle = exports.RowInlineInner = exports.ColumnInlineInner = exports.RowInner = exports.ColumnInner = exports.BaseInner = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const FieldLayout_1 = require("../FieldLayout");
const Label_1 = require("../FieldLayout/components/Label/Label");
const FieldLayout_2 = require("../FieldLayout/FieldLayout");
const FormLayout_1 = require("./");
const FormDescription_styles_1 = require("./components/FormDescription/FormDescription.styles");
const FormTitle_styles_1 = require("./components/FormTitle/FormTitle.styles");
const LabelGroup_styles_1 = require("./components/LabelGroup/LabelGroup.styles");
const NoLabelGroup_styles_1 = require("./components/NoLabelGroup/NoLabelGroup.styles");
const Separator_styles_1 = require("./components/Separator/Separator.styles");
const StackView_1 = require("../../StackView");
exports.BaseInner = (0, styled_components_1.default)(StackView_1.StackView) ``;
exports.ColumnInner = (0, styled_components_1.default)(StackView_1.StackView) ``;
exports.RowInner = (0, styled_components_1.default)(StackView_1.StackView) ``;
exports.ColumnInlineInner = (0, styled_components_1.default)(StackView_1.StackView) ``;
exports.RowInlineInner = (0, styled_components_1.default)(StackView_1.StackView) ``;
const inlineStyle = ({ shrink, theme }) => (0, styled_components_1.css) `
    > ${exports.ColumnInlineInner}
        > ${FormLayout_1.FormDescription.selector}:nth-child(n + 2)
        > *
        > ${FormDescription_styles_1.StyledFormDescriptionInner} {
        padding: ${theme.spacing.m} 0 0 0;
    }

    > ${exports.ColumnInlineInner} {
        display: table;
        table-layout: auto;
        width: 100%;
        white-space: nowrap;
        border-collapse: separate;
        border-spacing: 0;
        vertical-align: top;
    }

    table {
        border-spacing: 0;
    }

    > ${exports.ColumnInlineInner} > * {
        &:nth-child(n + 2) {
            // gap
            &${FieldLayout_2.FieldLayout.selector}
                > ${FieldLayout_1.FormFieldControl.selector}
                > ${FieldLayout_1.FormFieldControlBox.selector} {
                margin-top: ${theme.spacing.s};
            }
            &${FieldLayout_2.FieldLayout.selector} > ${Label_1.Label.selector} > * {
                margin-top: ${theme.spacing.s};
            }
            &${LabelGroup_styles_1.StyledLabelGroup} > ${LabelGroup_styles_1.StyledLabelGroupInnerLayout} {
                padding: ${theme.spacing.s} 0 0 0;
            }
            &${LabelGroup_styles_1.StyledLabelGroup} > ${Label_1.Label.selector} > * {
                margin: ${theme.spacing.s} 0 0 0;
            }
            &${FormLayout_1.NoLabelGroup.selector} > * > ${NoLabelGroup_styles_1.StyledNoLabelGroupLayout} {
                margin: ${theme.spacing.s} 0 0 0;
            }

            &${FormLayout_1.FormTitle.selector} > * > ${FormTitle_styles_1.StyledFormTitleInner} {
                margin: ${theme.spacing.m} 0 ${theme.spacing.s} 0;
            }

            &${FormLayout_1.Separator.selector} > * > ${Separator_styles_1.StyledSeparatorInner} {
                margin: ${theme.spacing.m} 0 ${theme.spacing.s} 0;
            }

            &${FormLayout_1.Separator.selector} > * > ${Separator_styles_1.StyledSeparatorInner} {
                margin: ${theme.spacing.m} 0 ${theme.spacing.s} 0;
            }
        }
    }

    > ${exports.ColumnInlineInner} > * {
        display: table-row;
        width: auto;
        vertical-align: top;
    }

    > ${exports.ColumnInlineInner} > * > ${Label_1.Label.selector} {
        display: table-cell;
        white-space: nowrap;
        padding-right: ${theme.spacing.s};
        vertical-align: top;
        width: 1%;

        & > * {
            vertical-align: top;
            display: flex;
            flex-direction: row;
            align-items: center;
            height: ${theme.spacing.xl};
            &::before {
                top: auto !important;
            }
        }
    }

    *::-ms-backdrop,
    > ${exports.ColumnInlineInner} > * > ${Label_1.Label.selector} {
        width: 1px;
    }

    > ${exports.ColumnInlineInner} > ${FieldLayout_2.FieldLayout.selector} > ${FieldLayout_1.FormFieldControl.selector} {
        display: table-cell;
        width: 100%;
        & > ${FieldLayout_1.HelpText.selector} {
            display: block;
        }
    }

    ${shrink &&
    (0, styled_components_1.css) `
        > ${exports.ColumnInlineInner} > * > ${Label_1.Label.selector} {
            width: auto;
        }
    `}

    ${shrink &&
    (0, styled_components_1.css) `
        > ${exports.ColumnInlineInner} > ${FieldLayout_2.FieldLayout.selector} > ${Label_1.Label.selector} + * {
            width: auto;
        }
    `}
`;
exports.inlineStyle = inlineStyle;
exports.BaseRoot = styled_components_1.default.table `
    display: block;
    border-spacing: 0;
    padding: 0;

    td {
        padding: 0;
    }

    ${FormTitle_styles_1.StyledFormTitleInner} {
        margin: ${({ theme }) => `${theme.spacing.s} 0`};
    }

    ${FormDescription_styles_1.StyledFormDescriptionInner} {
        padding: ${({ theme }) => `${theme.spacing.s} 0 0 0`};
    }

    ${FormLayout_1.FormTitle.selector} + ${FormLayout_1.FormDescription.selector} ${FormDescription_styles_1.StyledFormDescriptionInner} {
        padding-top: 0;
    }

    ${FormLayout_1.FormTitle.selector}:first-child, ${FormLayout_1.Separator.selector}:first-child {
        ${FormTitle_styles_1.StyledFormTitleInner} {
            margin: ${({ theme }) => `0 0 ${theme.spacing.s} 0`};
        }
    }

    ${FormLayout_1.FormDescription.selector}:first-child {
        ${FormDescription_styles_1.StyledFormDescriptionInner} {
            padding: 0;
        }
    }

    ${LabelGroup_styles_1.StyledLabelGroup} ${Label_1.Label.selector} {
        ${({ hasBottomLabelSpacing }) => hasBottomLabelSpacing &&
    (0, styled_components_1.css) `
                padding-bottom: ${({ theme }) => theme.spacing.xs};
            `}
        margin-bottom: 0;
    }

    ${FormLayout_1.NoLabelGroup.selector} > * > ${NoLabelGroup_styles_1.StyledNoLabelGroupLayout} > ${FormLayout_1.NoLabelGroup.selector} > * {
        display: block;
    }

    > * > * {
        &:last-child {
            &${FormLayout_1.FormTitle.selector} > * > ${FormTitle_styles_1.StyledFormTitleInner} {
                margin-bottom: 0 !important;
            }
            &${FormLayout_1.Separator.selector} > * > ${Separator_styles_1.StyledSeparatorInner} {
                margin-bottom: 0 !important;
            }
            &${FormLayout_1.FormDescription.selector} > * > ${FormDescription_styles_1.StyledFormDescriptionInner} {
                margin-bottom: 0 !important;
            }
        }
    }

    > * > * {
        &:first-child {
            &${FormLayout_1.FormTitle.selector} > * > ${FormTitle_styles_1.StyledFormTitleInner} {
                margin-top: 0 !important;
            }
            &${FormLayout_1.Separator.selector} > * > ${Separator_styles_1.StyledSeparatorInner} {
                margin-top: 0 !important;
            }
            &${FormLayout_1.FormDescription.selector} > * > ${FormDescription_styles_1.StyledFormDescriptionInner} {
                margin-top: 0 !important;
            }
        }
    }
`;
exports.NotInlineRoot = (0, styled_components_1.default)(exports.BaseRoot) `
    ${FormLayout_1.FormTitle.selector} {
        display: block;
        > * {
            display: block;
        }
    }

    ${FormLayout_1.Separator.selector} {
        display: block;
        > * {
            display: block;
        }
    }
`;
exports.ColumnRoot = (0, styled_components_1.default)(exports.NotInlineRoot) ``;
exports.RowRoot = (0, styled_components_1.default)(exports.NotInlineRoot) ``;
exports.ColumnRootWithInlineLabel = (0, styled_components_1.default)(exports.BaseRoot) `
    ${exports.inlineStyle};
`;
exports.RowRootWithInlineLabel = (0, styled_components_1.default)(exports.BaseRoot) `
    & > * {
        & > ${FieldLayout_2.FieldLayout.selector} {
            display: flex;
            flex-direction: row;
            & > ${Label_1.Label.selector} {
                margin-bottom: 0;
                padding-right: ${({ theme }) => theme.spacing.s};
                & > * {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    height: ${({ theme }) => theme.spacing.xl};
                }
                & > *:before {
                    top: auto !important;
                }
            }
        }
    }
`;
//# sourceMappingURL=FormLayout.styles.js.map